module.exports = __webpack_public_path__ + "madagascar.svg?3d9b8c12d948b6dd1b8aa0e6339d1d3f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/madagascar.svg
// module id = 219
// module chunks = 10